import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var DialogType = /*#__PURE__*/function (DialogType) {
  DialogType[DialogType["APPROVE"] = 0] = "APPROVE";
  DialogType[DialogType["REJECT"] = 1] = "REJECT";
  DialogType[DialogType["UNDER_REVIEW"] = 2] = "UNDER_REVIEW";
  return DialogType;
}({});
export var KycAdminDialogActions = /*#__PURE__*/function (KycAdminDialogActions) {
  KycAdminDialogActions[KycAdminDialogActions["CLOSE_DIALOG"] = 0] = "CLOSE_DIALOG";
  KycAdminDialogActions[KycAdminDialogActions["OPEN_APPROVE_DIALOG"] = 1] = "OPEN_APPROVE_DIALOG";
  KycAdminDialogActions[KycAdminDialogActions["OPEN_REJECT_DIALOG"] = 2] = "OPEN_REJECT_DIALOG";
  KycAdminDialogActions[KycAdminDialogActions["OPEN_UNDER_REVIEW_DIALOG"] = 3] = "OPEN_UNDER_REVIEW_DIALOG";
  return KycAdminDialogActions;
}({});
export var initialState = {
  currentDialog: null,
  isOpen: false,
  kycAbStatusUpdateDialogProps: {
    heading: '',
    contentText: '',
    submitButtonText: '',
    isCommentOptional: true,
    fieldLabel: '',
    helpText: ''
  }
};
export var openUnderReviewDialogState = {
  currentDialog: DialogType.UNDER_REVIEW,
  isOpen: true,
  kycAbStatusUpdateDialogProps: {
    heading: 'Mark as Under Review',
    contentText: 'Please provide more details below',
    submitButtonText: 'Mark as Under Review',
    isCommentOptional: true,
    fieldLabel: 'Admin comment',
    helpText: 'Providing a comment is optional, but recommended.'
  }
};
export var openApproveDialogState = {
  currentDialog: DialogType.APPROVE,
  isOpen: true,
  kycAbStatusUpdateDialogProps: {
    heading: 'Mark as Approved',
    contentText: 'Once you approve a request, you cannot change the status. Are you sure you want to approve this request?',
    submitButtonText: 'Mark as Approved',
    isCommentOptional: true,
    fieldLabel: 'Admin comment',
    helpText: 'Providing a comment is optional, but recommended.'
  }
};
export var openRejectDialogState = {
  currentDialog: DialogType.REJECT,
  isOpen: true,
  kycAbStatusUpdateDialogProps: {
    heading: 'Mark as Rejected',
    contentText: 'Are you sure you want to reject this request?',
    submitButtonText: 'Mark as Rejected',
    isCommentOptional: false,
    fieldLabel: 'Admin comment',
    helpText: 'Please provide a detailed comment.'
  }
};
export var reducer = function reducer(state, action) {
  switch (action.type) {
    case KycAdminDialogActions.CLOSE_DIALOG:
      {
        return _objectSpread({}, initialState);
      }
    case KycAdminDialogActions.OPEN_APPROVE_DIALOG:
      {
        return _objectSpread({}, openApproveDialogState);
      }
    case KycAdminDialogActions.OPEN_REJECT_DIALOG:
      {
        return _objectSpread({}, openRejectDialogState);
      }
    case KycAdminDialogActions.OPEN_UNDER_REVIEW_DIALOG:
      {
        return _objectSpread({}, openUnderReviewDialogState);
      }
    default:
      {
        return _objectSpread({}, initialState);
      }
  }
};